import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { hasAccessCode } from './api/accessCode';
import GatePage from './pages/GatePage.jsx';
import AnalyzePage from './pages/AnalyzePage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';

function RequireAccessCode({ children }) {
  const location = useLocation();
  if (!hasAccessCode()) {
    return <Navigate to="/gate" replace state={{ from: location }} />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/gate" element={<GatePage />} />
      <Route
        path="/"
        element={
          <RequireAccessCode>
            <AnalyzePage />
          </RequireAccessCode>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
